// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:M3s9o_ */\n.cvHr6{grid-gap:var(--audio-spacing-16);display:grid;gap:var(--audio-spacing-16);grid-template-columns:minmax(0,1fr);justify-items:start}.Zlh8-{height:26.375rem;overflow:hidden}.Zlh8-[data-folded=\"false\"]{height:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collapse": "cvHr6",
	"viewport": "Zlh8-"
};
export default ___CSS_LOADER_EXPORT___;
